// import  from 'react'
import Lottie from "react-lottie";
import animationData from "lotties/present.json";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PlayPauseIcon } from "utils/Icons";
import QueryChecker from "utils/queryChecker";

const Welcome = () => {
  const navigate = useNavigate();
  const { data } = useSelector((store) => store.auth);
  //   animation data/config
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const withQuery = QueryChecker(["promo","email","sId"]);

  return (
    <>
      <div className="d profile_step_body">
      <Fade direction="up" triggerOnce  duration={1400}>
        <Lottie
          options={defaultOptions}
          height={130}
          width={160}
          // eventListeners={[
          //   {
          //     eventName: "complete",
          //     callback: () => console.log("done 1"),
          //   },
          // ]}
        />
        </Fade>
        <br />
        <Fade direction="up" triggerOnce delay={1400} duration={1400}>
          <h3 style={{marginTop: "-40px"}}>
            Your customized plan <br /> is ready!
          </h3>
        </Fade>
        <Fade direction="up" triggerOnce delay={1450} duration={1500}>
          <p>
            Here is your very first recommended <br /> Mindpower Session
            <sup>TM</sup>
          </p>
        </Fade>
        <Fade direction="up" triggerOnce delay={1450} duration={1500}>
        <div className="first_session_card d_flex flex_col">
          <div className="session_img">
            <img src={data?.firstSession?.media?.image?.url} alt="" />
          </div>
          <div className="session_footer">
            <h5>{data?.firstName} {" "} {data?.firstSession?.title?.substring(2)}</h5>
            <div className="card_chip"><span> FIRST SESSION </span></div>
          </div>
          <div className="first_session_card_plyIcon">
          <PlayPauseIcon/>
          </div>
        </div>
        </Fade>
        <br />
      </div>
      <div className="mt_auto">
        <Fade direction="up" triggerOnce delay={1550} duration={1400}>
          <button
            onClick={() => navigate("/myAccount/purchase"+withQuery)}
            className="cs_btn w_100"
          >
            Continue
          </button>
        </Fade>
      </div>
    </>
  );
};

export default Welcome;
